import { API_USER_SERVICE } from "../config/Constants";
import { ITransferRequestDTO, ITransferFilterDTO, IBuildingDimensionsDTO, IFloorFitDTO, IRoomFitDTO, IRoomTemporaryDimensionsDTO, IRackFitDTO, IBinFitDTO } from "../interfaces/transfer";
import { getRequest, putRequest } from "./Rest";

export const updateTransfer = async (key: string, dto: ITransferRequestDTO) => {
    const path = `${API_USER_SERVICE}/transfer/${key}`;
    const response = await putRequest(path, dto);
    return response;
};

export const getTransfersByKey = async (key: string) => {
    const path = `${API_USER_SERVICE}/transfer/inventory/${key}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getInventoryByKey = async (key: string) => {
    const path = `${API_USER_SERVICE}/inventory/${key}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getTransfersWithFilters = async (dto: ITransferFilterDTO) => {
    const { searchTerm, buildingId, statuses, transferTypes, page = 0, size = 7 } = dto;

    let path = `${API_USER_SERVICE}/transfer?page=${page}&size=${size}`;

    if (searchTerm) {
        path += `&searchTerm=${encodeURIComponent(searchTerm)}`;
    }

    if (buildingId) {
        path += `&buildingId=${buildingId}`;
    }

    if (statuses && statuses.length > 0) {
        statuses.forEach(status => {
            path += `&statuses=${status}`;
        });
    }

    if (transferTypes && transferTypes.length > 0) {
        transferTypes.forEach(type => {
            path += `&transferTypes=${type}`;
        });
    }

    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getAvailableForFit = async (dto: IBuildingDimensionsDTO) => {
    const path = `${API_USER_SERVICE}/building/fit?length=${dto.length}&width=${dto.width}&height=${dto.height}&weight=${dto.weight}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getFloorsAvailableForFit = async (dto: IFloorFitDTO) => {
    const path = `${API_USER_SERVICE}/floor/fit?length=${dto.length}&width=${dto.width}&height=${dto.height}&weight=${dto.weight}&buildingId=${dto.buildingId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getRoomsAvailableForFit = async (dto: IRoomFitDTO) => {
    const path = `${API_USER_SERVICE}/room/fit?length=${dto.length}&width=${dto.width}&height=${dto.height}&weight=${dto.weight}&floorId=${dto.floorId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getRoomsAvailableForTemporary = async (dto: IRoomTemporaryDimensionsDTO) => {
    const path = `${API_USER_SERVICE}/room/temporary?length=${dto.length}&width=${dto.width}&height=${dto.height}&weight=${dto.weight}&buildingId=${dto.buildingId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getRacksAvailableForFit = async (dto: IRackFitDTO) => {
    const path = `${API_USER_SERVICE}/rack/fit?length=${dto.length}&width=${dto.width}&height=${dto.height}&weight=${dto.weight}&roomId=${dto.roomId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getBinsAvailableForFit = async (dto: IBinFitDTO) => {
    const path = `${API_USER_SERVICE}/bin/fit?length=${dto.length}&width=${dto.width}&height=${dto.height}&weight=${dto.weight}&rackId=${dto.rackId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const getAllBuildings = async () => {
    const path = `${API_USER_SERVICE}/building`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data?.data;
    return dataResponse;
};
